export const HIDE_PAGE_LIST = ["/student/usercenter/about"];
